import {AccItemStmtReportModel} from "./acc-item-stmt-report.model";
import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";

@Component({
    selector: "wbo-acc-item-stmt-report",
    templateUrl: "./acc-item-stmt-report.component.html",
    providers: [provideReportModel(AccItemStmtReportModel)]
})
export class AccItemStmtReportComponent extends AbstractReportPage {
    constructor(public model: AccItemStmtReportModel) {
        super();
    }
}
